import { TableRow } from '@mui/material'
import { TableCellWidth } from '@app/src/components/Table'
import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'
import React from 'react'
import { useIntl } from 'react-intl'
import { useFlags } from 'launchdarkly-react-client-sdk'

const ReportHeader: React.FC = () => {
  const { formatMessage } = useIntl()
  const { assessments } = useFlags()
  return (
    <TableRow>
      <TableHeaderCell minWidth={TableCellWidth.LARGE} label={formatMessage({ id: 'schemas.requestTemplate.title' })} />
      {assessments && (
        <TableHeaderCell minWidth={TableCellWidth.SMALL} label={formatMessage({ id: 'resourceTypes.assessment' })} />
      )}
      <TableHeaderCell
        minWidth={TableCellWidth.EXTRA_SMALL}
        label={formatMessage({ id: 'schemas.requestTemplate.questionnaireType' })}
      />
      <TableHeaderCell
        label={formatMessage({ id: 'automations.flagNumberHeader' })}
        minWidth={TableCellWidth.EXTRA_SMALL}
      />
      <TableHeaderCell minWidth={TableCellWidth.EMPTY} label="" />
    </TableRow>
  )
}

export default ReportHeader
